export const themes = ["Default", "K-Dark", "K-Light" ];
